import { useRef } from 'react';
import { Bell } from 'lucide-react';
import { useNavigate } from 'react-router';
import { useDataset } from '../api/hd';
import { AlertList } from '../components/AlertList';
import { useClickOutside } from '../lib/useClickOutside';
import { openAlert } from './alerts';
import { useUi } from '../stores/ui';

export function AlertsButton() {
  const { data } = useDataset('alerts');
  const open = useUi((s) => s.alertsOpen);
  const setOpen = useUi((s) => s.setAlertsOpen);
  const ref = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();
  useClickOutside(ref, open, () => setOpen(false));
  const n = data?.length ?? 0;
  return (
    <div ref={ref} style={{ position: 'relative' }}>
      <button
        type="button"
        className="icon-btn"
        aria-label={`Alerts (${n})`}
        aria-expanded={open}
        onClick={() => setOpen(!open)}
      >
        <Bell size={18} />
        {n > 0 && <span className="dot">{n}</span>}
      </button>
      {open && data && (
        <div
          className="popover"
          role="dialog"
          aria-label="Alerts"
          style={{ top: 38, right: 0, width: 360, padding: '6px 14px' }}
        >
          <AlertList
            alerts={data}
            onSelect={(a) => {
              setOpen(false);
              openAlert(a, navigate);
            }}
          />
        </div>
      )}
    </div>
  );
}
